// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

// Alpine.js
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
global.Alpine = Alpine;

// Import or define any Alpine components here

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.start();

// Lazysizes
import "lazysizes";

// Gallery Slider
import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

// ===================================================
// GSAP animations
// ===================================================
// Scroll Smoother & Split Text from GSAP
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const smoother = ScrollSmoother.create({
    wrapper: '#smooth-wrapper',
    content: '#smooth-content',
    smooth: false,
    effects: true
});

// ===================================================
// AOS-like animations but using greensock
// ===================================================
import scrollingAnimations from './modules/scrolling-animations';
scrollingAnimations.create({
    once: true
});

const main_carousel = document.querySelector('#main-carousel');

document.addEventListener( 'DOMContentLoaded', function () {
    if (main_carousel) {

        var main = new Splide( '#main-carousel', {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true,
            lazyLoad: 'nearby',
            // cover: true,
            heightRatio: 0.5625,
            video: {
                disableOverlayUI: true,
                playerOptions: {
                    vimeo: {
                        color: 'B78846'
                    }
                }
            }
        } );
        
        var thumbnails = new Splide( '#thumbnail-carousel', {
            fixedWidth: 200,
            fixedHeight: 126,
            perPage: 4,
            gap: 24,
            rewind: true,
            lazyLoad: true,
            pagination: false,
            arrows: false,
            isNavigation: true,
            breakpoints : {
                1025: {
                    fixedWidth: 150,
                    fixedHeight: 95,
                    perPage: 3,
                    gap: 14,
                },
                700: {
                    fixedWidth: 100,
                    fixedHeight: 63,
                    perPage: 2,
                    gap: 10,
                },
            },
        } );

        if (main, thumbnails) {
            main.sync( thumbnails );
            main.mount({ Video });
            thumbnails.mount();
        }

    }
});